'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styled = require('styled-components');
var polished = require('polished');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var gridRow = (() => component => {
  const GridRow = styled__default["default"](component).withConfig({
    componentId: "sc-1c4bd5q-0"
  })(["", ""], polished.clearFix());
  return GridRow;
});

exports["default"] = gridRow;
